module.exports = __webpack_public_path__ + "img/mt4logo2.f6187e71.svg";